import { Link } from "react-router-dom";
import { contactChannels, footerGroups, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl tracking-wide">
                {siteInfo.brand}
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90 max-w-sm">
              {siteInfo.intro}
            </p>
            <div className="mt-5 flex flex-col gap-2 text-sm text-background-200/90">
              {contactChannels.slice(0, 2).map((item) => (
                <span key={item.value} className="inline-flex items-center gap-2">
                  <i className={`${item.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {item.value}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-label font-medium text-sm tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/70 font-label">
            <p>
              © {year} {siteInfo.brand} · {siteInfo.slogan}
            </p>
            <p className="text-center sm:text-right">
              本站内容为话题观察与整理，不针对任何个人作事实性判定
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}